import React from 'react'

import Image from '../../../../../../components/presentation/Image'
import Text from '../../../../../../components/pdf/Text'
import Grid, { Col } from '../../../../../../components/pdf/Grid'

const OSFooter = () => {
  return (
    <Grid>
      <Col gutter={2}>
        <Image src="/pdfs/bosi/logo-rodape.jpg" />
      </Col>
      <Col flex={1} gutter={2}>
        <Text bold align="center">
          RFP - Consultoria, Treinamento e Desenvolvimento Pessoal
        </Text>
        <Text align="center">
          <strong>E-mail:</strong> rfpbia@hotmail.com
        </Text>
        <Text align="center">
          <strong>Telefone/WhatsApp:</strong> (31) 99676-1517
        </Text>
      </Col>
    </Grid>
  )
}

export default OSFooter
